import { useState } from "react";
import Hero from "@/components/site/Hero";
import Journey from "@/components/site/Journey";
import Services from "@/components/site/Services";
import RequestForm from "@/components/site/RequestForm";
import Footer from "@/components/site/Footer";

export default function Home() {
  const [service, setService] = useState("");
  const choose = (s) => {
    setService(s);
    document.getElementById("request")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <main className="starfield min-h-screen overflow-x-hidden" data-testid="home-page">
      <Hero />
      <Journey />
      <Services onChoose={choose} />
      <RequestForm service={service} setService={setService} />
      <Footer />
    </main>
  );
}
